import { ProfilesState, ProfilesTypes } from './types';

const profile = {
  id: '',
  name: '',
  type: 0,
  data: '',
  transportOperatorId: '',
  createdAt: '',
  order: 0,
  status: 0,
  expires: 0,
  expiresDate: null,
  facial: false,
  description: '',
  autoApprove: false,
  bdosOnly: false,
  hasSubsidy: false,
  validateCredit: false,
  walletChargeValue: 0,
  walletChargeTiming: 'UNIQUE',
  walletChargeTimingType: 0,
  allowCreditsByFare: {
    fareId: '',
    quantity: 0,
    timing: 0,
  },
};

export const INITIAL_STATE: ProfilesState = {
  profileData: profile,
  profileCreated: profile,
  profileSelected: profile,
  currentOperation: 'none',
  profilesList: [],
  filterProfilesList: [],
  profileOrder: [],
  profileLines: [],
  cid: {
    name: '',
  },
  totalCount: 0,
  error: false,
  loading: false,
};

function createReducer(initialState = INITIAL_STATE, handlers: any) {
  return function reducer(state = initialState, action: any) {
    // eslint-disable-next-line
    if (handlers.hasOwnProperty(action.type)) {
      return handlers[action.type](state, action);
    }
    return state;
  };
}

// List Profiles
const listProfilesRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
  profilesList: INITIAL_STATE.profilesList,
});

const listProfilesSuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
  profilesList: action.payload.profilesList,
  totalCount: action.payload.totalCount,
});

const listProfilesFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
  profilesList: INITIAL_STATE.profilesList,
});

// List Profile Lines
const listProfileLinesRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
  profileLines: INITIAL_STATE.profileLines,
});

const listProfileLinesSuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
  profileLines: action.payload.profileLines,
  totalCount: action.payload.totalCount,
});

const listProfileLinesFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
  profileLines: INITIAL_STATE.profileLines,
});

// Get CID
const getCidRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
  cid: INITIAL_STATE.cid,
});

const getCidSuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
  cid: action.payload.cid,
});

const getCidFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
  cid: INITIAL_STATE.cid,
});

// Filter Profiles
const filterProfilesRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
  filterProfilesList: INITIAL_STATE.filterProfilesList,
});

const filterProfilesSuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
  totalCount: action.payload.totalCount,
  filterProfilesList: action.payload.filterProfilesList,
});

const filterProfilesFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
  filterProfilesList: INITIAL_STATE.filterProfilesList,
});

// Get Profile
const getProfileRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
  profileData: INITIAL_STATE.profileData,
});

const getProfileSuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
  profileData: action.payload.profileData,
});

const getProfileFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
  profileData: INITIAL_STATE.profileData,
});

// Create Profile
const createProfileRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
  profileCreated: INITIAL_STATE.profileCreated,
});

const createProfileSuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
  profileCreated: action.payload.profileCreated,
});

const createProfileFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
  profileCreated: INITIAL_STATE.profileCreated,
});

// Update Profile
const updateProfileRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
});

const updateProfileSuccess = (state: any) => ({
  ...state,
  loading: false,
  error: false,
});

const updateProfileFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
});

// Update order Items Profile
const updateOrderRequest = (state: any, action: any) => ({
  ...state,
  loading: true,
  error: false,
  profileOrder: action.payload.profiles,
});

const updateOrderSuccess = (state: any) => ({
  ...state,
  loading: false,
  error: false,
});

const updateOrderFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
});

// Delete Profile
const deleteProfileRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
});

const deleteProfileSuccess = (state: any) => ({
  ...state,
  loading: false,
  error: false,
});

const deleteProfileFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
});

// Set Current Operation
const setCurrentOperation = (state: any, action: any) => ({
  ...state,
  currentOperation: action.payload.operation,
});

// Set Profile Selected
const setProfileSelected = (state: any, action: any) => ({
  ...state,
  profileSelected: action.payload.profileSelected,
});

// Reset Profile Selected
const resetProfileSelected = (state: any) => ({
  ...state,
  profileSelected: INITIAL_STATE.profileSelected,
});

const reducer = createReducer(INITIAL_STATE, {
  [ProfilesTypes.LIST_PROFILES_REQUEST]: listProfilesRequest,
  [ProfilesTypes.LIST_PROFILES_SUCCESS]: listProfilesSuccess,
  [ProfilesTypes.LIST_PROFILES_FAILURE]: listProfilesFailure,

  [ProfilesTypes.LIST_PROFILE_LINES_REQUEST]: listProfileLinesRequest,
  [ProfilesTypes.LIST_PROFILE_LINES_SUCCESS]: listProfileLinesSuccess,
  [ProfilesTypes.LIST_PROFILE_LINES_FAILURE]: listProfileLinesFailure,

  [ProfilesTypes.GET_CID_REQUEST]: getCidRequest,
  [ProfilesTypes.GET_CID_SUCCESS]: getCidSuccess,
  [ProfilesTypes.GET_CID_FAILURE]: getCidFailure,

  [ProfilesTypes.FILTER_PROFILES_REQUEST]: filterProfilesRequest,
  [ProfilesTypes.FILTER_PROFILES_SUCCESS]: filterProfilesSuccess,
  [ProfilesTypes.FILTER_PROFILES_FAILURE]: filterProfilesFailure,

  [ProfilesTypes.GET_PROFILE_REQUEST]: getProfileRequest,
  [ProfilesTypes.GET_PROFILE_SUCCESS]: getProfileSuccess,
  [ProfilesTypes.GET_PROFILE_FAILURE]: getProfileFailure,

  [ProfilesTypes.CREATE_PROFILE_REQUEST]: createProfileRequest,
  [ProfilesTypes.CREATE_PROFILE_SUCCESS]: createProfileSuccess,
  [ProfilesTypes.CREATE_PROFILE_FAILURE]: createProfileFailure,

  [ProfilesTypes.UPDATE_PROFILE_REQUEST]: updateProfileRequest,
  [ProfilesTypes.UPDATE_PROFILE_SUCCESS]: updateProfileSuccess,
  [ProfilesTypes.UPDATE_PROFILE_FAILURE]: updateProfileFailure,

  [ProfilesTypes.UPDATE_ORDER_PROFILE_REQUEST]: updateOrderRequest,
  [ProfilesTypes.UPDATE_ORDER_PROFILE_SUCCESS]: updateOrderSuccess,
  [ProfilesTypes.UPDATE_ORDER_PROFILE_FAILURE]: updateOrderFailure,

  [ProfilesTypes.DELETE_PROFILE_REQUEST]: deleteProfileRequest,
  [ProfilesTypes.DELETE_PROFILE_SUCCESS]: deleteProfileSuccess,
  [ProfilesTypes.DELETE_PROFILE_FAILURE]: deleteProfileFailure,

  [ProfilesTypes.SET_CURRENT_OPERATION]: setCurrentOperation,

  [ProfilesTypes.SET_PROFILE_SELECTED]: setProfileSelected,
  [ProfilesTypes.RESET_PROFILE_SELECTED]: resetProfileSelected,
});

export default reducer;
